import React, { useEffect, useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom';
import { RootState } from '../../store/store';
import { useSelector } from 'react-redux';

const SuccessPayment = () => {
  const navigate = useNavigate()
useEffect(()=>{
setTimeout(()=>{
  navigate("/")
},3000)
},[])
  return (
    <div className='Success'>
      
    <div className="container">
     
      <div className="checkmark">✔</div>
      <div className="success-text">Success!</div>
    </div>
    </div>
  )
}

export default SuccessPayment